/**
 * Background-tab alert for an incoming ring: the tab title flashes, and a
 * browser notification shows when the viewer already granted the permission.
 * The alert never asks for the permission.
 */

const TITLE_FLASH_MS = 1000;

function t(key, params) {
    return window.t ? window.t(key, params) : key;
}

export function createRingAlert() {
    let callId = null;
    let flashTimer = null;
    let baseTitle = '';
    let flashText = '';
    let notification = null;
    let onVisible = null;

    function flash() {
        // Another script can change the title during the ring. Keep that title as the base.
        if (document.title !== flashText) {
            baseTitle = document.title;
        }
        document.title = document.title === flashText ? baseTitle : flashText;
    }

    function notify(snapshot, text) {
        if (typeof window.Notification !== 'function' || window.Notification.permission !== 'granted') {
            return;
        }
        try {
            notification = new window.Notification(text, {
                body: snapshot.other?.name || snapshot.other?.username || '',
                icon: snapshot.other?.avatar || undefined,
                tag: `call-${snapshot.callId}`,
                requireInteraction: true,
            });
            notification.onclick = () => {
                window.focus();
                notification?.close();
            };
        } catch {
            notification = null;
        }
    }

    function stop() {
        callId = null;
        if (flashTimer) {
            clearInterval(flashTimer);
            flashTimer = null;
            if (document.title === flashText) {
                document.title = baseTitle;
            }
        }
        if (notification) {
            notification.close();
            notification = null;
        }
        if (onVisible) {
            document.removeEventListener('visibilitychange', onVisible);
            onVisible = null;
        }
    }

    function start(snapshot) {
        callId = snapshot.callId;
        flashText = snapshot.type === 'video' ? t('common.calls_incoming_video') : t('common.calls_incoming_audio');
        baseTitle = document.title;
        flashTimer = setInterval(flash, TITLE_FLASH_MS);
        notify(snapshot, flashText);
        onVisible = () => {
            if (!document.hidden) {
                stop();
            }
        };
        document.addEventListener('visibilitychange', onVisible);
    }

    return {
        update(snapshot) {
            const ringing = snapshot.status === 'ringing-in';
            if (!ringing || snapshot.callId !== callId) {
                if (callId !== null) {
                    stop();
                }
            }
            if (ringing && callId === null && document.hidden) {
                start(snapshot);
            }
        },
    };
}
